import { useQuery } from '@tanstack/react-query'
import Service from 'Service'
import useStores from 'hooks/useStores'
import { withholdingsQueryKey } from './queryKeys'

export { withholdingsQueryKey } from './queryKeys'

export function useWithholdingsQuery(dateFrom, dateTo, initial = 0, take = 100) {
  const { companyStore } = useStores()
  const companyKey = companyStore.selectedCompany?.Keycompany

  return useQuery({
    queryKey: withholdingsQueryKey(companyKey, dateFrom, dateTo, initial, take),
    queryFn: async () => {
      const data = await Service.Withholding.getByDate(dateFrom, dateTo, initial, take)
      return Array.isArray(data) ? data : []
    },
    enabled: Boolean(companyKey && dateFrom && dateTo)
  })
}
